// extracted by mini-css-extract-plugin
export default {"container":"Population_container__pXyZG"};